import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { PackageService } from '@services/packages/package.service';
import { DataTableComponent, DataTableEvent } from '../../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-package-list',
    templateUrl: './package-list.component.html',
    styleUrls: ['./package-list.component.scss'],
    providers: [PackageService],
    standalone: false
})
export class PackageListComponent implements OnInit {

  @Input() customerId: string;

  public title = 'All packages';

  public pageActions: PageAction[] = [];

  public columns = [
    { prop: 'title', translationString: 'packages.title' }, { prop: 'linkName', translationString: 'packages.linkName' },
    {
      prop: 'cache.lastPackageCacheJobExecuted', valueTransformer: function(data) {
        return moment(data).fromNow();
      }, translationString: 'packages.lastExecuted'
    },
    { prop: '_id', translationString: 'id' }
  ];
  public searchColumns = [{ prop: 'title' }, { prop: 'linkName' }];

  public params: any;

  @ViewChild('packageListTable') packageListTable: DataTableComponent;

  constructor(private router: Router, private dialogService: DialogService, public packageService: PackageService,) {
  }

  ngOnInit() {
    if (this.customerId) {
      this.params = {
        customerId: this.customerId
      };
    }
    this.createPageActions();
  }

  public async onRemove(event: DataTableEvent): Promise<any> {
    const res = await this.dialogService.confirm('Remove package?')
    if (!res) {
      return;
    }
    await this.packageService.remove(event.row._id);
    this.packageListTable.refresh();
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['packages', event.row._id]);
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'create_new_folder',
        title: 'Create new package',
        callback: () => {
          this.router.navigate(['packages', 'create']);
        }
      })
    ];
  }
}
